import {BaseEndpoint} from "../../../../base/endpoints/base.endpoint";
import {IParams} from "../../../../base/endpoints/iparams";
import {environment} from "../../../../../environments/environment";

export class SalesEndpoints extends BaseEndpoint {
  static ORDERS = {
    ORDER_ENDPOINT: environment.base_url + '/api/v1/orders',
    ORDER_ENDPOINT_V2: environment.base_url + '/api/v2/orders',
    ORDER_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/orders',
    SEARCH_FOR_VENDOR(endpoint: string, params: IParams) {
      return endpoint.concat("/vendor-orders").concat(BaseEndpoint.toParamString(params));
    },
    SEARCH_FOR_ADMIN(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.ORDER_ENDPOINT
    },
    GET(id: number): string {
      return this.ORDER_ENDPOINT + '/' + id
    },
    UPDATE(id: number): string {
      return this.ORDER_ENDPOINT + '/' + id
    },
    MAKE_PAYMENT(id: number, params: IParams): string {
      return this.ORDER_ENDPOINT + '/' + id + '/pay' + BaseEndpoint.toParamString(params)
    },
    CHANGE_STATUS(id: number, params: IParams): string {
      return this.ORDER_ENDPOINT + '/' + id + '/change-status' + BaseEndpoint.toParamString(params)
    },
    TOGGLE_PAYMENT_REMINDER(id: number, params: IParams): string {
      return this.ORDER_ENDPOINT + '/' + id + '/toggle-payment-reminder' + BaseEndpoint.toParamString(params)
    },
    DOWNLOAD_RECEIPT(id: number, params: IParams): string {
      return this.ORDER_ENDPOINT_V2 + '/' + id + '/receipt/html' + BaseEndpoint.toParamString(params)
    },
  }

  static CUSTOMERS = {
    CUSTOMER_ENDPOINT: environment.base_url + '/api/v2/customers',
    CUSTOMER_ENDPOINT_ADMIN: environment.base_url + '/api/v2/admin/customers',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(): string {
      return this.CUSTOMER_ENDPOINT
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(id: number): string {
      return this.CUSTOMER_ENDPOINT + '/' + id
    },
  }

  static STATISTICS = {
    STATS_ENDPOINT: environment.base_url + "/api/v1/inventory",
    STATS_ENDPOINT_V2: environment.base_url + "/api/v2/inventory",
    OVERVIEW_STATS(params: IParams) {
      return this.STATS_ENDPOINT + '/dashboard/overview/stats' + BaseEndpoint.toParamString(params)
    },
    LOW_STOCK_STATS(params: IParams) {
      return this.STATS_ENDPOINT + '/dashboard/low-stocks' + BaseEndpoint.toParamString(params)
    },
    MOST_PROFITABLE_PRODUCTS(params: IParams) {
      return this.STATS_ENDPOINT + '/dashboard/most-profitable-products' + BaseEndpoint.toParamString(params)
    },
    TOP_BUYING_CUSTOMERS(params: IParams) {
      return this.STATS_ENDPOINT_V2 + '/statistics/customers/top-buying' + BaseEndpoint.toParamString(params)
    },
    MOST_FREQUENT_CUSTOMERS(params: IParams) {
      return this.STATS_ENDPOINT_V2 + '/statistics/customers/most-frequent' + BaseEndpoint.toParamString(params)
    },
    MOST_PAYING(params: IParams) {
      return this.STATS_ENDPOINT_V2 + '/statistics/customers/most-paying' + BaseEndpoint.toParamString(params)
    },
    MOST_DUE(params: IParams) {
      return this.STATS_ENDPOINT_V2 + '/statistics/customers/most-due' + BaseEndpoint.toParamString(params)
    },
    BUYING_SELLING_PRICE(params: IParams) {
      return this.STATS_ENDPOINT + '/dashboard/buying-selling-price' + BaseEndpoint.toParamString(params)
    }
  }

  static STAGES = {
    STAGE_ENDPOINT: environment.base_url + '/api/v1/stages',
    STAGE_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/stages',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static LEADS = {
    LEAD_ENDPOINT: environment.base_url + '/api/v1/leads',
    LEAD_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/leads',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    FOLLOW_UPS(params: IParams) {
      return this.LEAD_ENDPOINT.concat("/follow-ups").concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static LEADPROPAGATIONS = {
    LEADPROPAGATION_ENDPOINT: environment.base_url + '/api/v1/lead-propagations',
    LEADPROPAGATION_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/lead-propagations',

    EMPLOYEE_ACTIVITIES(params: IParams) {
      return this.LEADPROPAGATION_ENDPOINT.concat("/employee-activities").concat(BaseEndpoint.toParamString(params));
    },
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }

  static ACQUISITIONCAMPAIGNS = {
    ACQUISITIONCAMPAIGN_ENDPOINT: environment.base_url + '/api/v1/acquisition-campaigns',
    ACQUISITIONCAMPAIGN_ENDPOINT_ADMIN: environment.base_url + '/api/v1/admin/acquisition-campaigns',
    SEARCH(endpoint: string, params: IParams) {
      return endpoint.concat(BaseEndpoint.toParamString(params));
    },
    CREATE(endpoint: string): string {
      return endpoint
    },
    GET(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
    UPDATE(endpoint: string, id: number): string {
      return endpoint + '/' + id
    },
  }
}
